import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayCamerasApiMeta } from "../apiMeta";
import {
  type HighwayCameraByCameraIdInput,
  highwayCameraByCameraIdInputSchema,
} from "./shared/cameras.input";
import { type Camera, cameraSchema } from "./shared/cameras.output";

/**
 * Metadata for the fetchHighwayCameraByCameraId endpoint
 */
export const highwayCameraByCameraIdMeta = {
  functionName: "fetchHighwayCameraByCameraId",
  endpoint: "/getCameraAsJson?CameraID={CameraID}",
  inputSchema: highwayCameraByCameraIdInputSchema,
  outputSchema: cameraSchema,
  sampleParams: { CameraID: 9818 },
  endpointDescription: "Get camera details by camera ID.",
} satisfies EndpointMeta<HighwayCameraByCameraIdInput, Camera>;

const { fetch, useHook } = createFetchAndHook<
  HighwayCameraByCameraIdInput,
  Camera
>({
  api: wsdotHighwayCamerasApiMeta,
  endpoint: highwayCameraByCameraIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/cameras.endpoints").camerasGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving camera details by camera ID
 */
export const fetchHighwayCameraByCameraId: FetchFactory<
  HighwayCameraByCameraIdInput,
  Camera
> = fetch;

/**
 * React Query hook for retrieving camera details by camera ID
 */
export const useHighwayCameraByCameraId: HookFactory<
  HighwayCameraByCameraIdInput,
  Camera
> = useHook;
